<div class="florder-page" @fadeInAnimation>
  <div class="florder-page-title">
    <span class="title"> {{ 'STOCK_COUNT.TITLE' | translate }} </span>
    <div class="buttons">
      <eps-button
        (buttonClick)="goToPrint()"
        [disabled]="sandbox.isLoading$ | async"
        buttonIcon="print"
        label="STOCK_COUNT.BUTTONS.PRINT"
        ></eps-button>
      <eps-button
        (buttonClick)="createStockCount()"
        type="primary"
        [disabled]="sandbox.isLoading$ | async"
        buttonIcon="plus-square"
        *ngIf="authMatrix && authMatrix.STOCK && authMatrix.STOCK.QUERY"
        label="STOCK_COUNT.BUTTONS.CREATE_STOCKCOUNT"
        ></eps-button>
    </div>
  </div>
  <div>
    <div class="florder-page-search">
      <app-stock-count-filter
        [filter]="filter"
        [shipTos]="shipTos"
        [isLoading]="sandbox.isLoading$ | async"
        (filterStockCounts)="filterStockCounts($event)"
      ></app-stock-count-filter>
    </div>
    <div class="florder-page-list">
      <app-stock-count-list
        [stockCounts]="stockCountsItems"
        [isLoading]="false"
        [isDownloading]="false"
        [filter]="filter"
        [totalItems]="totalItems"
        (openStockCount)="sandbox.openStockCount($event)"
        [shipTos]="shipTos"
      ></app-stock-count-list>
    </div>
  </div>
</div>
